import dynamic from 'helpers/dynamic';

// Global + Layout components
export { default as PrimaryHeader } from 'components/PrimaryHeader/components/PrimaryHeader';
export const USPHeader = dynamic(() => import('components/features/USPHeader'));
export const GlobalComponents = dynamic(() => import('setup/GlobalComponents'));
export const TopBanners = dynamic(() => import('components/topBanners'));
export const Footer = dynamic(() => import('components/footer'));
export const Chat = dynamic(() => import('components/chat'), { ssr: false });
export const Zowie = dynamic(() => import('components/chat/zowie/zowieRenderer'), { ssr: false });
export const MedicalFeaturedFooter = dynamic(() => import('components/featuredFooter/components/Medical/MedicalTheme'));
export const AdvisorFooter = dynamic(() => import('components/footer/components/AdvisorFooter'));
export const BrandFooter = dynamic(() => import('components/footer/components/BrandFooter'));
export const Breadcrumbs = dynamic(() => import('components/Breadcrumbs'));
export const UserMessageToast = dynamic(() => import('components/UserMessageToast'));
export const Logo = dynamic(() => import('components/Icon/Logo'));

// CMS placeholders
export const MatasPlusFAQPlaceholder = dynamic(
    () => import('components/matasPlus/matasPlusFAQ/matasPlusFAQPlaceholder')
);
export const MatasPlusUnboxingSlider = dynamic(() => import('components/matasPlus/unboxing/UnboxingOfferSlider'));
export const MatasPlusUnboxingSliderWithHeading = dynamic(
    () => import('components/matasPlus/unboxing/UnboxingOfferSliderWithHeading')
);
export const BrandSlider = dynamic(() => import('components/brandSlider'));
export const AdvisorContextPlaceholder = dynamic(() => import('components/advisorContextPlaceholder'));
export const MatasPlusCalculatorBanner = dynamic(
    () => import('components/matasPlus/placeholders/matasPlusCalculatorBanner')
);
export const MatasPlusSavingsBanner = dynamic(() => import('components/matasPlus/savingsBanner'));
export const Accordion = dynamic(() => import('components/shared/cmsPlaceholders/accordion'));
export const ClubMatasInPageNotification = dynamic(
    () => import('components/clubMatas/inPageNotification/ClubMatasInPageNotification')
);
export const ImageWithDisclaimerPlaceholder = dynamic(
    () => import('components/pages/placeholders/ImageWithDisclaimerPlaceholder')
);
export const ExtendedPlaceholder = dynamic(() => import('components/pages/placeholders/ExtendedPlaceholder'));
export const ImageBannerPlaceholder = dynamic(() => import('components/pages/placeholders/ImageBanner'));
export const Countdown = dynamic(() => import('components/countdown'));
export const MultiBuy = dynamic(() => import('components/multiBuy'));
export const StripedVerticalSpacer = dynamic(() => import('components/StripedVerticalSpacer'));
export const CMSProductSlider = dynamic(() => import('components/product/ProductSlider/components/CMSProductSlider'));
export const YouTubePlaceholder = dynamic(() => import('components/CMS/components/YouTubePlaceholder'));
export const VimeoPlaceholder = dynamic(() => import('components/CMS/components/VimeoPlaceholder'));
export const CMSButton = dynamic(() => import('components/CMS/components/Button/CMSButton'));
export const ArticleHeaderFromContext = dynamic(
    () => import('components/shared/cmsPlaceholders/components/ArticleHeaderFromContext')
);
export const InspirationAlsoReadPlaceholder = dynamic(
    () => import('components/CMS/components/InspirationAlsoReadPlaceholder')
);
export const InspirationArticleLeftHandPlaceholder = dynamic(
    () => import('components/CMS/components/InspirationArticleLeftHandPlaceholder')
);
export const InspirationArticleRightHandPlaceholder = dynamic(
    () => import('components/CMS/components/InspirationArticleRightHandPlaceholder')
);
export const TextContent = dynamic(() => import('components/CMS/components/TextContent'));
export const JsonLdContent = dynamic(() => import('components/CMS/components/JsonLdContent'));
export const VerticalSpacerPlaceholder = dynamic(() => import('components/CMS/components/VerticalSpacerPlaceholder'));
export const HorizontalLinePlaceholder = dynamic(() => import('components/CMS/components/HorizontalLinePlaceholder'));
export const AdvisorPlaceholder = dynamic(() => import('components/CMS/components/AdvisorPlaceholder'));
export const QuestionnaireContentBlock = dynamic(() => import('components/CMS/components/QuestionnaireContentBlock'));
export const QuestionnaireConsents = dynamic(() => import('components/CMS/components/QuestionnaireConsents'));
export const CallToAction = dynamic(() => import('components/CMS/components/CallToAction'));
export const SubMenu = dynamic(() => import('components/CMS/components/SubMenu'));
export const CustomContent = dynamic(() => import('components/CMS/components/CustomContent'));
export const ShippingOptionsPlaceholder = dynamic(() => import('components/CMS/components/ShippingOptionsPlaceholder'));
export const FollowButtonPlaceholder = dynamic(
    () => import('components/FollowButton/components/FollowButtonPlaceholder')
);
export const ProductListPlaceholder = dynamic(() => import('components/CMS/components/ProductList'));
export const LiveEventPlaceholder = dynamic(() => import('components/CMS/components/LiveEventPlaceholder'));
export const BeautyTrendBoxNotifyButtonPlaceholder = dynamic(
    () => import('components/CMS/components/BeautyTrendBoxNotifyButtonPlaceholder')
);
export const GiftCardBalancePlaceholder = dynamic(() => import('components/CMS/components/GiftCardBalancePlaceholder'));

// POS components and pages
export const BookingPosJournalViewModel = dynamic(
    () => import('components/booking/bookingFlow/BookingPosJournalViewModel')
);
export const PosFrontpage = dynamic(() => import('pos/frontpage/Frontpage'));
export const PosInit = dynamic(() => import('pos/init/InitPos'));
export const PosSubscriptionPage = dynamic(() => import('pos/Subscription/SubscriptionPage'));
export const PosPaymentPage = dynamic(() => import('pos/payment/PosPaymentPage'));
export const POSRefundPage = dynamic(() => import('components/pages/POS/RefundPage'));
export const AIAssistant = dynamic(() => import('components/AIAssistant'));
export const MobilePOSHeader = dynamic(() => import('components/MobilePOSHeader'));
export const PosSamplesPage = dynamic(() => import('components/pages/POS/SamplesPage'));
export const KicksIpadPosRecieptPage = dynamic(() => import('components/KicksIpadPosReciept'));

// Bakset + Checkout components and pages
export const CheckoutFooter = dynamic(() => import('components/footer/checkoutFooter'));
export const ProcessingPage = dynamic(() => import('components/pages/Checkout/components/Payment/ProcessingPage'));
export const ReceiptPage = dynamic(() => import('components/pages/Receipt'));
export const DeliveryPage = dynamic(() => import('components/pages/Checkout/components/Delivery'));
export const SummaryPage = dynamic(() => import('components/pages/Checkout/components/SummaryPage'));
export const KlarnaCheckoutPage = dynamic(() => import('components/pages/Checkout/components/KlarnaCheckout'));
export const CheckoutQuick = dynamic(() => import('components/checkoutQuick'));
export const BasketPage = dynamic(() => import('components/pages/Basket'));

// Booking pages
export const ConsultationProductList = dynamic(
    () => import('components/booking/consultations/ConsultationProductList')
);
export const ConsultationProduct = dynamic(() => import('components/booking/consultations/ConsultationProduct'));
export const BookingOverviewViewModel = dynamic(
    () => import('components/booking/bookingFlow/bookingOverviewViewModel')
);
export const BookingReceiptViewModel = dynamic(() => import('components/booking/bookingFlow/bookingReceiptViewModel'));

// MyProfile pages
export const MatasPlusPage = dynamic(() => import('components/matasPlus/matasPlusPage'));
export const SamplesProfile = dynamic(() => import('components/pages/MyProfile/MySampleProfile'));
export const BookingDetailsView = dynamic(() => import('components/booking/myProfile/bookingDetailsView'));
export const BookingListView = dynamic(() => import('components/booking/myProfile/bookingListView'));
export const MyProfileSubscriptionPage = dynamic(() => import('components/pages/MyProfile/SubscriptionPage'));
export const MyProfileSubscriptionDetailsPage = dynamic(
    () => import('components/pages/MyProfile/SubscriptionDetailsPage')
);
export const SubscriptionPendingPage = dynamic(() => import('components/myProfile/SubscriptionPendingPage'));
export const MyProfileDeliveryPage = dynamic(() => import('components/pages/MyProfile/DeliveryPage'));
export const MyProfileFrontPage = dynamic(() => import('components/pages/MyProfile/FrontPage'));
export const MyProfilePointPage = dynamic(() => import('components/pages/MyProfile/PointPage/PointPage'));
export const MyProfileSettingsPage = dynamic(() => import('components/pages/MyProfile/SettingsPage'));
export const MyProfileStorePage = dynamic(() => import('components/pages/MyProfile/StorePage'));
export const MyProfilePermissionPage = dynamic(() => import('components/pages/MyProfile/PermissionPage'));
export const MyProfileQuestionnaireTestResultPage = dynamic(
    () => import('components/pages/MyProfile/QuestionnaireTestResultPage')
);
export const MyProfileSignOffPage = dynamic(() => import('components/pages/MyProfile/SignOffPage'));
export const MyProfileOrdersPage = dynamic(() => import('components/pages/MyProfile/OrdersPage'));
export const MyProfileOrderDetailsPage = dynamic(
    () => import('components/pages/MyProfile/OrderDetailsPage/OrderDetailsPage')
);
export const MyProfileReviewsPage = dynamic(() => import('components/pages/MyProfile/ReviewsPage'));
export const MyProfilePersonalOffersPage = dynamic(() => import('components/pages/MyProfile/PersonalOffersPage'));
export const MyProfileReviewRequestPage = dynamic(
    () => import('components/pages/MyProfile/ReviewsPage/ReviewRequestPage')
);
export const MyBonusChecksPage = dynamic(() => import('components/pages/MyProfile/MyBonusChecksPage'));
export const FavoritesPage = dynamic(() => import('components/pages/MyProfile/FavoritesPage'));
export const MyFavoritesPage = dynamic(() => import('components/pages/MyProfile/MyFavoritesPage'));
export const MyFavoritesListPage = dynamic(() => import('components/pages/MyProfile/MyFavoritesListPage'));
export const BrandClub = dynamic(() => import('views/myprofile/brandClub'));
export const BrandClubFrontPage = dynamic(() => import('views/myprofile/brandClub/frontPage'));
export const BrandClubBonusGifts = dynamic(() => import('views/myprofile/brandClub/bonusGifts'));
export const BrandClubSignup = dynamic(() => import('views/myprofile/brandClub/signup'));

// Various components
export const Store = dynamic(() => import('modules/findStore/store'));
export const BannerRenderer = dynamic(() => import('components/booking/banners/BannerRenderer'));
export const LiveEvents = dynamic(() => import('components/liveEvents'));
export const CampaignHeader = dynamic(() => import('components/plp/campaignHeader'));
export const ProductItem = dynamic(() => import('components/shared/productItem/ProductItem'));
export const SplashRenderer = dynamic(() => import('components/shared/Splash')); // Used on splash overview page

// Various pages
export const ProductPage = dynamic(() => import('components/pages/PDP'));
export const ReviewPage = dynamic(() => import('components/pages/Review'));
export const GranularCampaignPermissionPage = dynamic(() => import('components/pages/GranularCampaignPermissionPage'));
export const VisualSearch = dynamic(() => import('components/pages/VisualSearch'));
export const BrandList = dynamic(() => import('components/BrandList'));
export const ProductListPage = dynamic(() => import('components/pages/PLP'));
export const SearchPage = dynamic(() => import('components/pages/Search'));

// Contentful
export const ContentfulPage = dynamic(() => import('components/pages/Contentful'));
export const ContentfulPreviewPage = dynamic(() => import('components/pages/Contentful/Preview'));
export const ArticleLandingPage = dynamic(() => import('components/pages/ArticleUniverse/ArticleLandingPage'));

// Almost full React pages - SHOULD BE REACTIFIDED
export const AdvisorList = dynamic(() => import('components/advisorList'));
export const AdvisorInfo = dynamic(() => import('components/advisorProfile/components/AdvisorInfo'));
export const AdvisorProfileRightContainer = dynamic(
    () => import('components/advisorProfile/AdvisorProfileRightContainer')
);

// Has refs, but not sure CSHTML files are actively used anymore - NEEDS BACKEND
export const FindStore = dynamic(() => import('modules/findStore'));
export const MyProfileInformation = dynamic(() => import('views/myprofile/myProfileInformation'));
export const InlineConnectedContent = dynamic(() => import('components/connectedContent/inlineConnectedContent'));
export const FullwidthConnectedContent = dynamic(() => import('components/connectedContent/fullwidthConnectedContent'));
export const ProductDisplayConnectedContent = dynamic(
    () => import('components/connectedContent/productDisplayConnectedContent')
);
export const GwpDiscountModels = dynamic(() => import('components/gwpDiscountModels'));
export const SubscriptionProductCard = dynamic(
    () => import('components/subscriptionProductCard/subscriptionProductCardButton')
);
export const ProgressiveDiscountPDPHandle = dynamic(() => import('components/progressiveDiscount/pdpHandle'));
export const LoginInfo = dynamic(() => import('components/login/loginInfo'));
export const ProductList = dynamic(() => import('components/shared/productList'));
export const ProductRecommendation = dynamic(() => import('components/productRecommendation/ProductRecommendation'));
export const HighlightedCampaign = dynamic(() => import('components/highlightedCampaign'));
export const SubscriptionUSP = dynamic(() => import('components/features/subscription/SubscriptionUSP'));
export const DigitalBonusGiftsHeader = dynamic(() => import('components/plp/BrandGifts/Header'));
export const ProductSlider = dynamic(() => import('components/product/ProductSlider'));
export const SearchSuggestion = dynamic(() => import('components/SearchSuggestion'));
export const OrderDetailed = dynamic(
    () => import('components/pages/MyProfile/OrderDetailsPage/components/OrderDetails/OrderDetailed')
);

// Old basket CSHTML files that are most likely redudant - NEEDS BACKEND
export const DeliveryPreview = dynamic(() => import('components/basket/DeliveryPreview'));
export const BasketPowerstepOpener = dynamic(() => import('components/basket/BasketPowerstep/BasketPowerstepOpener'));
export const CheckoutDeliveryContinueButton = dynamic(
    () => import('components/checkout/components/DeliveryContinueButton')
);
export const SignupNudgingCard = dynamic(() => import('components/clubMatas/onboarding/SignupNudgingCard'));
export const SignupNudgingCardWithImage = dynamic(
    () => import('components/clubMatas/onboarding/SignupNudgingCardWithImage')
);
export const CampaignBasketNudge = dynamic(
    () => import('components/features/CampaignInfo/components/CampaignBasketNudge')
);
export const SubscriptionNudge = dynamic(() => import('components/subscriptionNudge'));
export const SampleBasketEntrance = dynamic(() => import('components/samples/components/entrance'));
export const DonationBanner = dynamic(() => import('components/donationBanner'));
export const PersonalOffer = dynamic(() => import('components/basket/personalOffer'));
export const ExpectedDeliveryHandle = dynamic(() => import('components/expecteddelivery'));
